"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapTranslationsToKeys = mapTranslationsToKeys;
/**
 * Replaces translated texts with their keys in a translations object. This is useful for debugging purposes.
 *
 * @example
 * const translations = {
 *  greeting: 'Hello',
 *  farewell: 'Goodbye',
 * };
 * const namespace = 'common';
 *
 * const translationKeys = mapTranslationsToKeys(translations, namespace);
 * // translationKeys will be:
 * // {
 * //   greeting: '[common:greeting]',
 * //   farewell: '[common:farewell]',
 * // }
 *
 * @typeParam T Type of translations object
 * @param translations A map of translation keys to translations itself.
 * @param namespace The namespace to which the translation keys belong.
 * @returns Remapped translations with values replaced by their keys.
 */
function mapTranslationsToKeys(translations, namespace) {
  return Object.fromEntries(Object.keys(translations).map(key => [key, formatKeyValue(key, namespace)]));
}
function formatKeyValue(key, namespace) {
  return `[${namespace}:${key}]`;
}
//# sourceMappingURL=mapTranslationsToKeys.js.map